import { render, staticRenderFns } from "./overview.vue?vue&type=template&id=263ac838&"
import script from "./overview.vue?vue&type=script&lang=ts&"
export * from "./overview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports